
import React from "react";
import { Button } from "@/components/ui/button";
import { Facebook, Loader2 } from "lucide-react";
import { ConnectionState } from "./types";

interface FacebookLoginTabProps {
  isLoading: boolean;
  isInitialized: boolean;
  connectionStatus: { state: ConnectionState; message: string };
  handleConnect: () => Promise<void>;
}

export const FacebookLoginTab: React.FC<FacebookLoginTabProps> = ({
  isLoading,
  isInitialized,
  connectionStatus,
  handleConnect
}) => {
  return (
    <div className="text-center py-4">
      <Button
        onClick={handleConnect}
        className="bg-[#1877F2] hover:bg-[#0e6edc] text-white w-full"
        disabled={connectionStatus.state === ConnectionState.CONNECTING || !isInitialized}
      >
        {connectionStatus.state === ConnectionState.CONNECTING ? (
          <>
            <Loader2 className="mr-2 h-4 w-4 animate-spin" />
            Verbinde...
          </>
        ) : (
          <>
            <Facebook className="mr-2 h-4 w-4" />
            Mit Facebook anmelden
          </>
        )}
      </Button>
      {isLoading && <p className="text-sm text-gray-500 mt-2">Lade Facebook SDK...</p>}
    </div>
  );
};
